import Paper from '@material-ui/core/Paper';
import './Badge.scss'

export default function AlertBadgeLabel({ text, type }) {
  const alertBadgeData = {
    'critical': {
      title: 'Critical',
      color: 'critical',
    },
    'high': {
      title: 'High',
      color: 'high',
    },
    'medium':{
      title: 'Medium',
      color: 'medium',
    },
    'low': {
      title: 'Low',
      color: 'low',
    },
  };
  const badgeProp = alertBadgeData[type.toLowerCase()];
  if (!badgeProp) {
    return null;
  }
  const paperContainerClassName = () => {
    return "chip-container alerts inspect-content";
  }
  const badgeDataContainerClassNames = () => {
    return "alerts-container inspect-content-header";
  }
  return (
    <Paper component="ul" className={paperContainerClassName()}>
      <div className={badgeDataContainerClassNames()}>
        <div>
          <div className={`squareBadge ${badgeProp.color} tags`} title={badgeProp.title}>
            <span className="squareBadge-text">{badgeProp.title}</span>
          </div>
        </div>
      </div>
    </Paper>
  );
}